import { c as _c } from "react/compiler-runtime";
import Button from '../Button';
import { CancelBkgIcon } from '../icons/CancelBkgIcon';
import { StyledFlyout, StyledGridTopButtonsContainer } from './styles';
import { type FlyoutProps } from './types';
const Flyout = props => {
  const $ = _c(15);
  const {
    isExpanded,
    topLeftAdornment,
    onClose,
    children,
    closeText,
    className
  } = props;
  let t0;
  if ($[0] !== topLeftAdornment) {
    t0 = topLeftAdornment != null ? topLeftAdornment : <div />;
    $[0] = topLeftAdornment;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CancelBkgIcon />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = topLeftAdornment == null ? closeText ?? "Cancel" : "";
  let t3;
  if ($[3] !== onClose || $[4] !== t2) {
    t3 = <Button rightIcon={t1} onClick={onClose} scheme="light" variant="text">{t2}</Button>;
    $[3] = onClose;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t0 || $[7] !== t3) {
    t4 = <StyledGridTopButtonsContainer>{t0}{t3}</StyledGridTopButtonsContainer>;
    $[6] = t0;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children || $[10] !== className || $[11] !== isExpanded || $[12] !== onClose || $[13] !== t4) {
    t5 = <StyledFlyout anchor="right" open={isExpanded} onClose={onClose} className={className}>{t4}{children}</StyledFlyout>;
    $[9] = children;
    $[10] = className;
    $[11] = isExpanded;
    $[12] = onClose;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default Flyout;
export { Flyout };